export default __webpack_public_path__ + "static/media/SENAIT_FR_SEQ16.d6da0b9b.mp3";